<template>
  <RevInfoBlock
    :icon="IconBlocked"
    :title="i18n(translations.onboardingAndListingsNotCreated)"
    variant="danger"
  >
  </RevInfoBlock>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconBlocked } from '@ds/icons/IconBlocked'

import translations from './ListingsBlock.translations'

const i18n = useI18n()
</script>
